var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import http from 'axios';
import { Video } from '@app/global/video';
export default Vue.extend({
    props: {
        uri: String,
        autoplay: {
            type: Boolean,
            default: false,
        },
        quality: {
            type: String,
            default: null
        },
        adaptiveStreaming: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            video: null,
            playing: false,
        };
    },
    mounted: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uri) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getVideoData()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$nextTick()];
                    case 2:
                        _a.sent();
                        new Video(this.$refs.video, {
                            adaptiveStreaming: this.adaptiveStreaming,
                            autoplay: this.autoplay
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    methods: {
        getVideoData: function () {
            var _this = this;
            return http.get('/api/video/' + this.uri.replace('/videos/', '')).then(function (res) {
                _this.video = res.data;
            });
        },
    },
    computed: {
        videoStorageKey: function () {
            return "video-data-".concat(this.uri.replace('/videos/', ''));
        },
        bestQualitySource: function () {
            var sources = Object.keys(this.video.sources).filter(function (source) { return source != 'hls'; });
            if (sources.includes('qhd')) {
                return this.video.sources.qhd;
            }
            else if (sources.includes('hd')) {
                return this.video.sources.hd;
            }
            else if (sources.includes('sd')) {
                return this.video.sources.sd;
            }
            return this.video.sources[0];
        },
        videoThumbnailUrl: function () {
            if (!this.video || !this.video.raw.pictures) {
                return '';
            }
            return 'https://i.vimeocdn.com/video' + this.video.raw.pictures.uri.substring(this.video.raw.pictures.uri.lastIndexOf('/'));
        }
    },
    activated: function () {
        if (this.video && this.autoplay) {
            var video = this.$refs.video;
            video.muted = true;
            var playPromise = video.play();
            if (typeof playPromise !== 'undefined') {
                playPromise.catch(function (err) {
                    // ignore errors
                });
            }
        }
    },
    deactivated: function () {
        if (this.video) {
            this.$refs.video.pause();
        }
    }
});
